import { Component, ElementRef, HostListener, Inject, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Home } from 'src/app/shared/content/content';
import { HomePage } from 'src/app/shared/models/home.model';
import { DataPrices, VehiclesPrice } from 'src/app/shared/models/vehicles.model';
import { CmsService } from 'src/app/shared/services/cms.service';
import { DealershipService } from 'src/app/shared/services/dealership.service';
import { ImagePreloadingService } from 'src/app/shared/services/image-preloading.service';
import { LocalStorageService, VENDA_ASSISTIDA_STORAGE } from 'src/app/shared/services/local-storage.service';
import { SeoService } from 'src/app/shared/services/seo.service';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';
import { UsersService } from 'src/app/shared/services/users.service';
import { VehiclesService } from 'src/app/shared/services/vehicles.service';
import { environment } from 'src/environments/environment';
import type { SwiperOptions } from 'swiper/types';
import { initSwiper } from '../../shared/utils/swiper.util';
import { ResultModel } from '../../shared/models/base-request-result.model';


@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    standalone: false
})
export class HomeComponent implements OnInit {
	@ViewChild('carsArea') carsArea!: ElementRef;
	@ViewChild('swiper') set swiperRef(ref: ElementRef<HTMLElement> | undefined) {
		if (ref) initSwiper(ref.nativeElement, this.config);
	}
	homeData: HomePage = {} as HomePage;
	isMobile: boolean = false;
	config: SwiperOptions = {
		slidesPerView: 1,
		spaceBetween: 24,
		lazyPreloadPrevNext: 1,
		pagination: {
			clickable: true,
		},
		allowTouchMove: true,
		cssMode: false,
	};
	prices: DataPrices[] | undefined;
	isLoadingContent: boolean = false;
	textHome = Home;

	constructor(
		private vehiclesService: VehiclesService,
		private cmsService: CmsService,
		private userAgent: UserAgentService,
		private seoService: SeoService,
		private localStorage: LocalStorageService,
		private route: ActivatedRoute,
		private dealerService: DealershipService,
		private imagePreloadingService: ImagePreloadingService,
		@Inject(PLATFORM_ID) private platformId: Object
	) {
		route.queryParams.subscribe(params => {
			if (params['dealerid'] || params['sellerid']) {
				this.localStorage.clear();
			}
			if (params['dealerid']) {
				this.dealerService.getDealerById(params['dealerid']).subscribe({
					next: (res: any) => {
						this.localStorage.setItem('ROD-LP-DEALER-dealerid', params['dealerid']);
						this.localStorage.setItem('ROD-LP-DEALER-dealer', JSON.stringify(res.data));
						UsersService.isLPDEALER.emit();
					},
					error: (err: any) => {},
				});
			}
			if (params['sellerid']) {
				this.localStorage.setItem('ROD-LP-DEALER-sellerid', params['sellerid']);
			}
			if (params['vendaassistida']) {
				this.localStorage.setItem(VENDA_ASSISTIDA_STORAGE, params['vendaassistida']);
			}
		});
		this.isMobile = userAgent.verifyMobile();
	}

	ngOnInit(): void {
		this.localStorage.removeItem('hasSimulations');
		if (!isPlatformBrowser(this.platformId)) return;
		this.getPageContent();
	}

	getPageContent() {
		this.isLoadingContent = true;
		this.cmsService.resolve('home-v3').subscribe((result: ResultModel<HomePage>) => {
			this.homeData = result.content;

			const imageUrls = this.extractImageUrls(result.content);

			if (imageUrls.length > 0) {
				this.imagePreloadingService.preloadImages(imageUrls);
			}

			this.isLoadingContent = false;
			this.seoService.addTags(result.seo);
			this.getVehiclesPrice();
		});
	}

	private extractImageUrls(data: any): string[] {
		if (data) {
			const imageUrls = [];

			if (data.newBanners && data.newBanners.desktopPrimary) {
				imageUrls.push(data.banner.desktopPrimary.src);
			}
			if (data.newBanners && data.newBanners.desktopSecondary) {
				imageUrls.push(data.banner.desktopSecondary.src);
			}
			if (data.newBanners && data.newBanners.desktopTertiary) {
				imageUrls.push(data.banner.desktopSecondary.src);
			}

			return imageUrls;
		}
		return [];
	}

	getPrice(annataId: string) {
		return this.prices?.filter(price => price.annataModel == annataId)[0].salesPrice;
	}

	getVehiclesPrice() {
		this.vehiclesService.getVehiclesPrice().subscribe((result: VehiclesPrice) => {
			this.prices = result?.data;
		});
	}

	getName(value: string, type: string) {
		return type == 'model' ? value.split(' ')[0] : value.split(value.split(' ')[0])[1];
	}

	returnImage(path?: string) {
		if (path) {
			return path?.includes('wp-content') ? environment.imgUrl + path : path;
		}
		return;
	}

	trackByFn(index: number) {
		return index;
	}

	@HostListener('window:resize')
	onResize() {
		this.isMobile = this.userAgent.verifyMobile();
	}
}
